import axios from 'axios';

export default (creds) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .patch(process.env.VUE_APP_API_ADMIN_LOCATION + `vouchers/${creds.id}`, creds.payload)
      .then((data) => {
        let voucher = {};
        if (data.data) {
          voucher = data.data.data;
        }
        resolve(voucher);
      })
      .catch((error) => {
        reject(error);
      });
  });
  return promise;
};
